import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
